<kt-portlet>
  <kt-portlet-header>
    <ng-container ktPortletTitle>
      <h3 class="card-head-title">
        <span>Special Purpose Property Types</span>
      </h3>
    </ng-container>

    <ng-container ktPortletTools>
      <a routerLink="../add" mat-raised-button color="primary" type="button">
        <span>Add</span>
      </a>
    </ng-container>
  </kt-portlet-header>

  <kt-portlet-body>
    <div class="mat-table-wrapper">
      <mat-table class="lmat-elevation-z8 table-striped" [dataSource]="dataSource$">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.ref_num }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <ng-template #popTitle>
              {{ 'GENERAL.INFORMATION_TOOLTIP.TITLE' | translate }}
            </ng-template>
            <ng-template #popContent>
              <p>
                <b>Status:</b> {{getItemStatusString(item.status)}}
              </p>
              <p>
                <b>Used (times):</b>
                {{item.used_times == 0
                ? 'Never used'
                : ('Used ' + item.used_times + ' time' + (item.used_times == 1 ? '' : 's'))}}
              </p>
              <p [innerHTML]="'GENERAL.INFORMATION_TOOLTIP.CREATED_BY' | translate:{
                                    username: item.createdBy ? item.createdBy : 'Unknown',
                                    date: (item.created_at | date: 'dd MMM yyyy':currentUser.settings.time_zone_gmt)
                                }">
              </p>
              <p [innerHTML]="'GENERAL.INFORMATION_TOOLTIP.LAST_EDITED_BY' | translate:{
                                    username: item.lastUpdatedBy ? item.lastUpdatedBy : 'Unknown',
                                    date: (item.updated_at | date: 'dd MMM yyyy':currentUser.settings.time_zone_gmt)
                                }">
              </p>
            </ng-template>

            <button mat-icon-button color="primary" [ngbPopover]="popContent" [popoverTitle]="popTitle"
              *ngIf="currentUser">
              <mat-icon [matTooltip]="'GENERAL.TOOLTIP.INFORMATION' | translate">info</mat-icon>
            </button>
            <a [routerLink]="['../edit', item.id]" mat-icon-button color="primary">
              <mat-icon>create</mat-icon>
            </a>

            <button mat-icon-button color="warn" type="button" (click)="onDelete(item.id)"
              [disabled]="!item.can_be_deleted"
              >
              <mat-icon>delete</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="property_type">
          <mat-header-cell *matHeaderCellDef>Purpose Type</mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.property_type_name }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="size">
          <mat-header-cell *matHeaderCellDef>Size</mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.size }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="consideration">
          <mat-header-cell *matHeaderCellDef>
            Consideration
          </mat-header-cell>
          <mat-cell *matCellDef="let ac">
            <div style="display: flex; flex-direction: column;" *ngIf="ac.display_tenures.length > 0 else no_data">
              <div *ngFor="let t of ac.display_tenures">
                <ng-container *ngIf="t.consideration_type_id === 1">
                  {{t.total_consideration.toFixed(2) | mask:'separator':{thousandSeparator: ','} }} {{t.currency}}
                </ng-container>
                <ng-container *ngIf="t.consideration_type_id === 2">
                  <ng-container *ngIf="t.rent_input_amount_type === 'total'">
                    {{t.total_consideration.toFixed(2) | mask:'separator':{thousandSeparator: ','} }}
                    {{t.currency}}/{{t.rent_basis}}
                  </ng-container>
                  <ng-container *ngIf="t.rent_input_amount_type === 'per_units'">
                    {{(t.total_consideration * (t.rent_size ? t.rent_size.size : 0)).toFixed(2) |
                    mask:'separator':{thousandSeparator: ','} }} {{t.currency}}/{{t.rent_basis}}
                  </ng-container>
                </ng-container>
              </div>
            </div>
            <ng-template #no_data>
              {{ 'No Data' }}
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="source_date">
          <mat-header-cell *matHeaderCellDef>
            Date of information/transaction
          </mat-header-cell>
          <mat-cell *matCellDef="let ac">
            <div style="display: flex; flex-direction: column;" *ngIf="ac.display_tenures.length > 0 else no_data">
              <div *ngFor="let t of ac.display_tenures">
                {{t.source.source_date ? (t.source.source_date | dateWithOffset: ac.locationData.time_offset) : 'N/A'}}
              </div>
            </div>
            <ng-template #no_data>
              {{ 'No Data' }}
            </ng-template>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns; let index = index"
          [ngClass]="{gray: index%2}"></mat-row>
      </mat-table>
    </div>
  </kt-portlet-body>
</kt-portlet>